module.exports = __webpack_public_path__ + "images/d-belousov_big-cbe9af.jpg";